




















































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import search from '@/store/modules/search';

@Component
export default class Menubar extends Vue {
    searchTerm: string = '';

    search() {
        search.search(this.searchTerm);
        if (this.$router.currentRoute.name !== 'search') {
            this.$router.push({ name: 'search' });
        }
    }

    logout() {
        user.logout();
        this.$router.push({ name: 'start' });
    }

    get userName() {
        return user.user ? user.user.Name : '???';
    }
}
